<template>
  <div id="mobile-topnav">
    <div class="main_header">
      <div class="main_header__mobile-nav">
        <input type="checkbox" class="toggler" ref="checkbox" />
        <div class="hamburger"><div></div></div>
        <div class="mobile-links">
          <div>
            <img
              src="../assets/img/navbarlogo.png"
              alt="sponsor a mum charity logo"
              class="logo-img"
            />
            <div class="">
              <ul>
                <li @click="closeNavbar('about-us')">
                  <button class="mobile-link">
                    About us
                  </button>
                </li>
                <li @click="closeNavbar('contact')">
                  <button class="mobile-link">
                    Contact.
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileNav",
  components: {},

  data() {
    return {
      isModalVisible: false,
    };
  },

  methods: {
    closeNavbar(section) {
      this.$refs.checkbox.checked = false;
      this.$emit("clicked", section);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mobilenav.scss";
</style>
